<template>
  <div id="topbar">
    <div id="topbar-left">
      <img src="../../assets/img/logo_rsp.png" alt="rsp logo" />
    </div>
    <div id="topbar-center">
      <div id="topbar-center">
        <div id="topbar-center-date">{{ room.event_date | formatEventDate }}</div>
        <div id="topbar-center-title">{{ room.public_title }}</div>
      </div>
    </div>
    <div id="topbar-right">
      <div v-if="is_login" class="loggedin">
        <a @click="logout">ログアウト</a>
      </div>
      <div v-else>
        <a @click="login">ログイン</a>
      </div>
    </div>
  </div>
</template>

<script>
import M from "materialize-css";
import moment from "moment-timezone";
import cookie from "js-cookie";

import { auth } from "./../../App.vue";

export default {
  name: "TheTopbar",
  props: {
    is_login: Boolean,
    room: Object,
    current_user_nickname: String
  },
  filters: {
    formatEventDate: function(event_date) {
      return moment(event_date)
        .tz("Asia/Tokyo")
        .format("YYYY.MM.DD");
    }
  },
  methods: {
    login: function() {
      const room_id = this.$router.currentRoute.params.room_id;
      const redirect_to = encodeURI(
        `${process.env.VUE_APP_URL}/login?redirectRoomId=${room_id}`
      );
      window.location.href = `${process.env.VUE_APP_LOGIN_URL}?redirectTo=${redirect_to}`;
    },
    logout: function() {
      const ok = window.confirm(
        `${this.base64Decode(
          this.current_user_nickname
        )} さん\nログアウトしますか？`
      );
      if (!ok) {
        return;
      }

      // ログアウトボタンを押したユーザー判定用の Bool 値であり、常に true である。
      // 本 Cookie が存在する場合、自動ログインが行われない
      cookie.set("rsp_logouted", true);

      auth.signOut().then(function() {
        M.toast({
          html: "ログアウトが完了しました",
          displayLength: 2000
        });
        return;
      });
    },
    base64Decode: function(encoded) {
      return decodeURIComponent(escape(window.atob(encoded)));
    }
  }
};
</script>

<style lang="scss" scoped>
#topbar {
  position: fixed;
  top: 0;
  width: 100%;
  height: $topbar_height;
  background-color: $color_pink;
  z-index: 1;
  height: $topbar_height;
  box-shadow: 0px 2px 2.35px 0.15px rgba(0, 0, 0, 0.15);

  #topbar-left {
    position: fixed;
    top: 6px;
    left: 9.5px;
    z-index: 1;
    img {
      height: 35px;
    }
  }
  #topbar-center {
    text-align: center;
    font-family: HiraKakuPro-W6;
    margin: 10.5px 0px;
    #topbar-center-date {
      font-size: 10px;
      line-height: 1;
      color: $color_white;
      font-weight: 500;
    }
    #topbar-center-title {
      color: $color_white;
      font-size: 15px;
    }
  }
  #topbar-right {
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 1;
    div {
      height: 30px;
      width: 75px;
      border: solid 1px #cccccc;
      border-radius: 15px;
      background-color: $color_white;
      text-align: center;
      a {
        height: 23px;
        font-family: HiraKakuPro-W6;
        font-size: 12px;
        line-height: 2.17;
        color: $color_pink;
        user-select: none;
      }
    }
    .loggedin {
      opacity: 0.7;
    }
  }
}
</style>
